import { ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import { useForm } from '@chiroup/hooks/useForm';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import useClinics from '../../../hooks/useClinics';
import RoleSelectModal from '../../clinics/detail/RoleSelectModal';
import Filters from '../../common/Filters';
import Modal from '../../common/Modal';
import SearchInput from '../../common/fields/inputs/SearchInput';
import List from '../../common/list/List';
import ListItem from '../../common/list/ListItem';

type Props = {
  isOpen: OpenClosedStates;
  setIsOpen: (arg: OpenClosedStates) => void;
  refetch: () => void;
  userID?: string;
};

const AddClinicModal = ({ isOpen, setIsOpen, userID, refetch }: Props) => {
  const [confirmModalState, setConfirmModalState] = useState<OpenClosedStates>(
    OpenClosedStates.Closed
  );
  // const [createUserModalState, setCreateUserModalState] =
  //   useState<OpenClosedStates>(OpenClosedStates.Closed);
  const [clinicToAdd, setClinicToAdd] = useState<number>();
  const { data, isFetching, fetchNextPage, isFetchingNextPage, hasNextPage, onSearch } =
    useClinics();
  const { value, onChange } = useForm<{ search: string }>(
    {
      search: '',
    },
    {}
  );

  useEffect(() => {
    onSearch(value?.search || '');
  }, [value, onSearch]);

  const addUserToClinic = (clinic: any) => {
    setClinicToAdd(clinic.ID);
    setConfirmModalState(OpenClosedStates.Open);
  };

  const onSuccess = () => {
    // createToast({
    //   title: 'Successfully added user to a clinic!',
    //   description: <div>Hi</div>,
    //   type: ToastTypes.Success,
    //   duration: 5000,
    // });
    setConfirmModalState(OpenClosedStates.Closed);
    setIsOpen(OpenClosedStates.Closed);
    // setCreateUserModalState(OpenClosedStates.Closed);
    refetch();
  };

  const footerButtons = [
    {
      text: 'Close',
      onClick: () => setIsOpen(OpenClosedStates.Closed),
      color: ButtonColors.plainWithBorder,
    },
  ];

  return (
    <Modal
      isOpen={isOpen === OpenClosedStates.Open}
      close={() => setIsOpen(OpenClosedStates.Closed)}
      header={{ title: 'Add clinic to user' }}
      footer={{ buttons: footerButtons }}
      darkBg
    >
      <div>
        <Filters main={<SearchInput onChange={onChange('search')} value={value.search} />} />

        {/* <Button
          text="Create new user"
          onClick={() => {
            setCreateUserModalState(OpenClosedStates.Open);
          }}
          className="w-full h-1/2"
          color={ButtonColors.plainWithBorder}
        /> */}
      </div>
      <List
        isFetching={isFetching}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
      >
        {data?.pages?.map((page, pageNumber) => (
          <React.Fragment key={`users-page-${pageNumber}`}>
            {page?.data?.map((row, i) => (
              <div onClick={() => addUserToClinic(row)} key={row.ID}>
                <ListItem index={i}>
                  <div className="flex items-center justify-between space-x-4">
                    <div className="min-w-0">
                      <div className="relative group flex items-center space-x-4">
                        <svg
                          className="shrink-0 w-12 h-12 text-gray-400 group-hover:text-gray-500"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="2 2 16 16"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <div className="space-y-3">
                          <div className="flex items-center space-x-3">
                            <span className="block">
                              <h2 className="text-sm font-medium leading-4">
                                <span className="absolute inset-0" />
                                {row.name}
                              </h2>
                            </span>
                          </div>
                          <div className="text-sm leading-4 text-gray-500 group-hover:text-gray-900 font-medium truncate">
                            {row.plan}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="sm:hidden">
                      <svg
                        className="h-5 w-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="hidden sm:flex flex-col shrink-0 items-end space-y-3">
                      <p className="flex text-gray-500 text-sm leading-4 space-x-2">
                        <span>{row.active ? 'Active' : 'Inactive'}</span>
                        <span>
                          {row.renewDate
                            ? `Renews:  ${dayjs(row.renewDate).format('MM/DD/YYYY')}`
                            : ''}
                        </span>
                      </p>
                    </div>
                  </div>
                </ListItem>
              </div>
            ))}
          </React.Fragment>
        ))}
      </List>
      <RoleSelectModal
        isOpen={confirmModalState}
        setIsOpen={setConfirmModalState}
        clinicID={clinicToAdd}
        user={{ ID: userID }}
        closeAddUserModal={() => setIsOpen(OpenClosedStates.Closed)}
        onSuccess={onSuccess}
      />
      {/* <UserCreateModal
        state={createUserModalState}
        close={() => setCreateUserModalState(OpenClosedStates.Closed)}
        onCreate={onSuccess}
        clinicID={clinicID}
      /> */}
    </Modal>
  );
};

export default AddClinicModal;
